<app-form-field
[formGroup]="formGroup"
[fieldControlName]="fieldControlName"
[fieldLabel]="fieldLabel"
[col]="col"
type="text"
(valueChanged)="valueChanged.emit($event)"
(keyup)="debounce(onAddressSearchChange($event), 300)"
#addressSearchTextField
[validatorOrOpts]="validatorOrOpts"
></app-form-field>
<ng-template #optionsTemplate
>
<div class="predictive-search-results">
    <div
  *ngFor="let result of addressResults"
  (click)="onAddressSearchResultItemClick(result)"
  >
  {{ result.description }}
    </div>
  </div>
</ng-template>
